import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useFragment } from "react-relay";

import { CurrentClubWeather } from "@/components/CurrentClubWeather";
import { FacilityLogoSideNav } from "@/features/Session/components/FacilityLogo/FacilityLogoSideNav";
import { BookButtonHomeHeader } from "@/screens/Home/components/HomeHeader/components/BookButtonHomeHeader";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { getFill } from "@whoosh/utilities/src/Cloudinary";

import { NavigationMenuClubCard_session$key } from "./__generated__/NavigationMenuClubCard_session.graphql";

const NAV_IMAGE_ID = "nav-image_b4yfml.png";

type NavigationMenuClubCardProps = {
  sessionRef: NavigationMenuClubCard_session$key | null;
  onNavigate?: () => void;
};

export const NavigationMenuClubCard = ({
  sessionRef,
  onNavigate,
}: NavigationMenuClubCardProps) => {
  const session =
    useFragment(NavigationMenuClubCardFragmentString, sessionRef) || null;
  const club = session?.currentClientProfile?.member?.club;

  const currentClubBG = club?.appCustomization?.backgroundImage?.publicId;

  const navImage = getFill(
    currentClubBG ? currentClubBG : NAV_IMAGE_ID,
    1400,
    933
  )?.toURL();

  return (
    <Box
      borderRadius="4"
      shadowColor="black"
      shadowOffset={{ width: 0, height: 17 }}
      shadowOpacity={0.08}
      shadowRadius={40}
    >
      <VStack
        borderRadius="4"
        overflow="hidden"
        borderWidth={1}
        borderColor="outline-default"
      >
        <Image
          accessible={false}
          source={{ uri: navImage }}
          style={{ width: "100%", height: 120 }}
          resizeMode="cover"
        />
        <Box
          position="relative"
          top={-33}
          alignItems="center"
          style={{ marginBottom: -28 }}
        >
          <Box
            borderRadius="2"
            overflow="hidden"
            borderWidth={2}
            borderColor="surface-primary"
          >
            <FacilityLogoSideNav clubRef={club || null} />
          </Box>
        </Box>
        <VStack paddingHorizontal={4} paddingBottom={4} alignItems="center">
          <VStack alignItems="center" gap={1} marginBottom={4}>
            <Text variant="mainHeading">{club?.name}</Text>
            <CurrentClubWeather showMinimal />
          </VStack>
          <BookButtonHomeHeader
            sessionRef={session ?? null}
            onNavigate={onNavigate}
          />
        </VStack>
      </VStack>
    </Box>
  );
};

export const NavigationMenuClubCardFragmentString = graphql`
  fragment NavigationMenuClubCard_session on Session {
    ...BookButtonHomeHeader_session
    currentClientProfile {
      member {
        club {
          id
          name
          ...FacilityLogoSideNavFragment_club
          appCustomization {
            backgroundImage {
              # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
              publicId: renderingKey
            }
          }
        }
      }
    }
  }
`;
